import { VoidCallback } from 'types/callbacks';

import styles from './DownloadButton.module.css';

type Props = {
  onClick: VoidCallback;
};

const DownloadButton = ({ onClick }: Props) => {
  return (
    <div className={styles.Container} onClick={onClick}>
      <div className={styles.Title}>Download</div>
    </div>
  );
};

export default DownloadButton;
